import React from "react";
import boat from "../../assets/hero_image.png";
import background from "../../assets/backgrounds/landing-1.svg";
import Section from "../../components/section";

const Hero: React.FC = () => {
  return (
    <Section backgroundImage={background}>
      <div className="flex items-center justify-center min-h-screen">
        <div className="md:w-1/2 md:text-left md:pr-8 text-center">
          <div>
            <p className="text-4xl md:text-5xl text-[#4c0012] sm:mt-5">
              Helping
              <span className="font-semibold text-[#FE2E00]">
                {" "}
                Singaporean youths{" "}
              </span>
              navigate critical issues facing our society.
            </p>
            <br />
            <p className="text-blue-950 text-2xl sm:text-2xl mb-24">
              We are an NPO commited to nurturing social cohesion in Singapore
              via media initiatives and thought-provoking discussions to drive
              positive change and foster a more connected society.
            </p>
          </div>
        </div>
        <div className="hidden md:flex md:w-1/2 justify-center items-center">
          <img src={boat} alt="Group discussion" />
        </div>
      </div>
    </Section>
  );
};

export default Hero;
